import { getLoginRedirectUrlFromQueryParam } from '../routing/getLoginRedirectUrlFromQueryParam';

const isHubSpotHost = hostname => /^(app|local).*\.hubspot(qa)?\.com/.test(hostname);

const isOauthPath = pathname => /^\/oauth\/.*/.test(pathname);

const isHubSpotOauthRedirect = (hostname, pathname) => isHubSpotHost(hostname) && isOauthPath(pathname);

const removeAffiliateCharacterEncoding = url => url.replace(/\+/g, encodeURIComponent(' '));

export const parseScopesFromUrl = scopesInUrl => removeAffiliateCharacterEncoding(scopesInUrl);
export const isOauthFlow = () => {
  const loginRedirectUrl = getLoginRedirectUrlFromQueryParam(false);

  if (loginRedirectUrl) {
    const {
      hostname,
      pathname
    } = loginRedirectUrl;
    return isHubSpotOauthRedirect(hostname, pathname);
  }

  return false;
};